export default __webpack_public_path__ + "static/media/Picture (1).db917f9d.png";